import { Link } from 'react-router-dom';
import { X, Github as GithubIcon, Linkedin as LinkedinIcon, Mail, Zap } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-[#0a0f1c] pt-16 sm:pt-24 pb-8 sm:pb-12 text-slate-400">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 sm:gap-16 mb-12 sm:mb-20">
                    <div className="sm:col-span-2 lg:col-span-4">
                        <div className="flex items-center gap-3 mb-6 sm:mb-8">
                            <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-blue-600/20">
                                <Zap className="w-6 h-6 fill-white" />
                            </div>
                            <span className="font-bold text-2xl text-white tracking-tight">Imago</span>
                        </div>
                        <p className="text-slate-500 text-sm sm:text-base leading-relaxed mb-8 sm:mb-10 max-w-sm">
                            API testing and development platform built for modern teams. Build, test, and ship with confidence.
                        </p>
                        <div className="flex gap-4">
                             {[
                                { icon: X, href: '#' },
                                { icon: GithubIcon, href: '#' },
                                { icon: LinkedinIcon, href: '#' },
                                { icon: Mail, href: '#' }
                             ].map((social, i) => (
                                <a key={i} href={social.href} className="w-10 h-10 rounded-xl bg-slate-900 flex items-center justify-center hover:bg-slate-800 transition-all text-slate-400 hover:text-white border border-slate-800">
                                    <social.icon className="w-5 h-5" />
                                </a>
                             ))}
                        </div>
                    </div>

                    <div className="lg:col-span-2">
                        <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-6 sm:mb-8">Product</h4>
                        <ul className="space-y-3 sm:space-y-4 text-sm sm:text-base">
                            <li><Link to="#" className="hover:text-white transition-colors">Features</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Vision</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">For Teams</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Pricing</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Changelog</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-6 sm:mb-8">Resources</h4>
                        <ul className="space-y-3 sm:space-y-4 text-sm sm:text-base">
                            <li><Link to="#" className="hover:text-white transition-colors">Documentation</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">API Reference</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Tutorials</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Blog</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Community</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-6 sm:mb-8">Company</h4>
                        <ul className="space-y-3 sm:space-y-4 text-sm sm:text-base">
                            <li><Link to="#" className="hover:text-white transition-colors">About</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Careers</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Contact</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Terms of Service</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="pt-8 sm:pt-12 border-t border-slate-900 flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6">
                    <p className="text-xs sm:text-sm">© 2026 Imago by Spense. All rights reserved.</p>
                    <div className="flex gap-6 sm:gap-8 text-xs sm:text-sm font-medium">
                        <Link to="#" className="hover:text-white transition-colors">Marketing Site</Link>
                        <Link to="#" className="hover:text-white transition-colors">Platform</Link>
                        <Link to="#" className="hover:text-white transition-colors">UAT</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
